import resume from "../assets/files/jorden-gerovac-professional-resume.pdf";
import PageLayout from "../components/PageLayout";
import ExperienceItem from "../components/ExperienceItem";

const workExperience = [
  {
    title: "Full Stack Developer",
    company: "Borrowell",
    dates: " Apr 2026 – Present",
    bullets: [
      "Delivered a self-serve internal tool for handling of product originations using .NET and React; reduced reliance on engineering intervention and replaced a previously slow and manual process",
      "Supported the rewards functionality through building promotional campaigns with quiz, milestone and analytics tracking functionality using .NET and React Native; aided in launching a successful 4 million member campaign",
      "Built a member-facing gamification system giving members visibility into earned and locked badges using .NET and React Native; resulted in boosted engagement and retention for members across the rewards experience",
    ],
    skills: [
      "C#",
      "TypeScript",
      "NoSQL",
      "SQL",
      ".NET",
      "React Native",
      "Docker",
      "Azure",
    ],
  },
  {
    title: "Senior Software Developer",
    company: "Veriday",
    dates: " Jul 2020 – Apr 2026",
    bullets: [
      "Developed a business performance dashboard in Liferay to display historical sales data of products sold online and in-store over custom date ranges using React and Spring Boot; allowed vendors to make promotional decisions based on daily insights",
      "Developed a product data transformation portal using Micronaut and React where vendors were able to upload a .csv or .xlsx spreadsheet and data was transformed and unified between business data stored in GCP (Google Cloud Platform) and the uploaded third party vendor data; improved workflow efficiency by greatly reducing time and resources needed to perform daily data reviews",
      "Led the implementation of a consolidated project portal application with Jira integration and Keycloak authentication using React and Spring Boot; allowed for administrators to view and maintain the consolidation of all vendor projects and permissions dynamically",
      "Built a JSON parsing program in Java that used scraped data to calculate scores based on negative and threatening language using the Apache OpenNLP natural language library; used this data to uncover and map illicit activity in local communities using ArcGIS",
    ],
    skills: [
      "Java",
      "JavaScript",
      "SQL",
      "React",
      "Redux",
      "Vue",
      "Spring Boot",
      "Docker",
      "Liferay",
      "GraphQL",
    ],
  },
  {
    title: "Software Developer",
    company: "MoviWear",
    dates: " May 2019 – Aug 2019",
    bullets: [
      "Developed VoIP and virtual assistant applications for Android wearables using Android Studio; created custom voice commands based on feedback from the families of seniors actively using the SOS smart watch",
      "Updated and modernized consumer mobile application frontend using React and developed .NET APIs for seamless integration with backend services like Stripe; deployed using DigitalOcean droplets",
      "Responsible for rebranding and launching products in North and South America along with a corresponding product website and marketing campaign; integrated the SOS smart watch and alert button into international markets",
    ],
    skills: [
      "C#",
      "JavaScript",
      "Java",
      "Kotlin",
      "SQL",
      ".NET",
      "React",
      "Android Studio",
    ],
  },
];

const education = [
  {
    title: "Computer Science (B.Sc.)",
    company: "Toronto Metropolitan University (Ryerson University)",
    dates: "2017 - 2020",
  },
];

function Experience() {
  return (
    <PageLayout title="Experience" className="experience-page-container">
      <div className="experience-content container">
        <div className="row gx-5 mb-5">
          <div className="col-lg-4 fade-in">
            <div className="experience-section">
              <h5 className="subtle">Work Experience</h5>
            </div>
          </div>
          <div className="col-lg-8 fade-in">
            {workExperience.map((item) => (
              <ExperienceItem key={item.company} {...item} />
            ))}
          </div>
        </div>
        <div className="row gx-5">
          <div className="col-lg-4 fade-in">
            <div className="experience-section">
              <h5 className="subtle">Education</h5>
            </div>
          </div>
          <div className="col-lg-8 fade-in">
            {education.map((item) => (
              <ExperienceItem key={item.company} {...item} />
            ))}
          </div>
        </div>
        <div className="row gx-5 my-4">
          <div className="col-lg-4">
            <h5 className="back-home-button">
              <a
                className="partial-underline-sm"
                href={resume}
                target="_blank"
                rel="noreferrer"
              >
                View full resume <span>&#187;</span>
              </a>
            </h5>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default Experience;
